import { render } from "./EditBankingDialog.vue?vue&type=template&id=18868463&scoped=true"
import script from "./EditBankingDialog.vue?vue&type=script&lang=js"
export * from "./EditBankingDialog.vue?vue&type=script&lang=js"

import "./EditBankingDialog.vue?vue&type=style&index=0&id=18868463&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18868463"]])

export default __exports__